import { Users } from "lucide-react";
import { anexoUrlAbsoluto } from "../services/tarefas";

/**
 * Avatar default pra conversas de GRUPO no chat. Mostra:
 *  - `fotoUrl` (se houver) — imagem custom subida pelo admin/gestor.
 *  - senão, ícone `Users` (duas carinhas) num círculo gradiente azul, mesmo
 *    padrão visual do app (favicon/branding).
 *
 * Substitui o antigo `Hash` cinza/roxo.
 */
export function GrupoAvatar({ fotoUrl, tamanho = 32, titulo }: {
  fotoUrl?: string | null;
  tamanho?: number;
  titulo?: string;
}) {
  if (fotoUrl) {
    return (
      <img
        src={anexoUrlAbsoluto(fotoUrl)}
        alt={titulo || "grupo"}
        title={titulo}
        style={{ width: tamanho, height: tamanho }}
        className="rounded-full object-cover shrink-0 border border-slate-200 dark:border-slate-700 bg-slate-100"
      />
    );
  }
  const iconSize = Math.round(tamanho * 0.55);
  return (
    <div
      className="rounded-full flex items-center justify-center shrink-0 bg-gradient-to-br from-blue-500 to-blue-700 text-white"
      style={{ width: tamanho, height: tamanho }}
      title={titulo}
    >
      <Users size={iconSize} />
    </div>
  );
}
